import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import store from './redux/store';
import App from './App';
import './index.css';
import { CartProvider } from './context/CartContext';

// Прибираємо шум у production
if (process.env.NODE_ENV === 'production') {
    console.log   = () => {};
    console.debug = () => {};
    console.warn  = () => {};
    // console.error залишаємо — він потрібен для відстеження реальних помилок
}

// Знаходимо кореневий елемент
const rootElement = document.getElementById('root');
// Створюємо root за допомогою нового API
const root = ReactDOM.createRoot(rootElement);

// Рендеримо додаток за допомогою root.render
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <CartProvider>
        <App />
      </CartProvider>
    </Provider>
  </HelmetProvider>
);
